/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'FR': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 11',
    data: '<clipPath id="svgicon-FR-a"><path pid="0" d="M14.75 2.25c0-1.097-.903-2-2-2H2.25c-1.097 0-2 .903-2 2v6.5c0 1.097.903 2 2 2h10.5c1.097 0 2-.903 2-2v-6.5z"/></clipPath><g clip-path="url(#svgicon-FR-a)"><path pid="1" _fill="#f44653" d="M10 0h5v11h-5z"/><path pid="2" _fill="#fff" d="M5 0h5v11H5z"/><path pid="3" _fill="#1035bb" d="M0 0h5v11H0z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/FR.js